const BillingSubscribtionCheckbox = () => {
  const label = document.querySelector("label[for='billing_subscribtion_newsletter']");

  if (label) {
    label.insertAdjacentHTML('beforeend', `<span class="billing-subscribtion-checkbox"></span>`);
  }
}

export default BillingSubscribtionCheckbox;